/* eslint-disable */

export const protobufPackage = "od_protos.journey.data.categories";

/**
 * ============================================
 * Enums
 * ============================================
 */
export interface MortgageCategory {
  event?:
    | { $case: "applicationStart"; applicationStart: MortgageCategory_ApplicationStartEvent }
    | { $case: "stepView"; stepView: MortgageCategory_StepViewEvent }
    | { $case: "stepComplete"; stepComplete: MortgageCategory_StepCompleteEvent }
    | { $case: "applicationSubmit"; applicationSubmit: MortgageCategory_ApplicationSubmitEvent }
    | { $case: "applicationDecision"; applicationDecision: MortgageCategory_ApplicationDecisionEvent }
    | { $case: "integrationStart"; integrationStart: MortgageCategory_IntegrationStartEvent }
    | { $case: "integrationResult"; integrationResult: MortgageCategory_IntegrationResultEvent }
    | { $case: "productPricingStart"; productPricingStart: MortgageCategory_ProductPricingStartEvent }
    | { $case: "outOfPocketMaxSelection"; outOfPocketMaxSelection: MortgageCategory_OutOfPocketMaxSelectionEvent }
    | { $case: "downPaymentSelection"; downPaymentSelection: MortgageCategory_DownPaymentSelectionEvent }
    | { $case: "productPricingSelect"; productPricingSelect: MortgageCategory_ProductPricingSelectEvent }
    | { $case: "productPricingSeeDetails"; productPricingSeeDetails: MortgageCategory_ProductPricingSeeDetailsEvent }
    | { $case: "rateLockStart"; rateLockStart: MortgageCategory_RateLockStartEvent }
    | { $case: "rateLockComplete"; rateLockComplete: MortgageCategory_RateLockCompleteEvent }
    | { $case: "disclosuresSigned"; disclosuresSigned: MortgageCategory_DisclosuresSignedEvent }
    | { $case: "validationError"; validationError: MortgageCategory_ValidationErrorEvent }
    | { $case: "prequalStart"; prequalStart: MortgageCategory_PrequalStartEvent }
    | { $case: "prequalStepView"; prequalStepView: MortgageCategory_PrequalStepViewEvent }
    | { $case: "prequalStepComplete"; prequalStepComplete: MortgageCategory_PrequalStepCompleteEvent }
    | { $case: "prequalSubmit"; prequalSubmit: MortgageCategory_PrequalSubmitEvent }
    | { $case: "prequalDecision"; prequalDecision: MortgageCategory_PrequalDecisionEvent }
    | { $case: "lowerReferral"; lowerReferral: MortgageCategory_LowerReferralEvent }
    | { $case: "prequalValidationError"; prequalValidationError: MortgageCategory_PrequalValidationErrorEvent }
    | undefined;
}

export enum MortgageCategory_StepKey {
  UNKNOWN_STEP = 0,
  VERIFICATION = 1,
  ABOUT_YOU = 2,
  REAL_ESTATE = 3,
  EMPLOYMENT_INCOME = 4,
  ASSETS = 5,
  DECLARATIONS = 6,
  REVIEW_SUBMIT = 7,
  UNRECOGNIZED = -1,
}

export function mortgageCategory_StepKeyFromJSON(object: any): MortgageCategory_StepKey {
  switch (object) {
    case 0:
    case "UNKNOWN_STEP":
      return MortgageCategory_StepKey.UNKNOWN_STEP;
    case 1:
    case "VERIFICATION":
      return MortgageCategory_StepKey.VERIFICATION;
    case 2:
    case "ABOUT_YOU":
      return MortgageCategory_StepKey.ABOUT_YOU;
    case 3:
    case "REAL_ESTATE":
      return MortgageCategory_StepKey.REAL_ESTATE;
    case 4:
    case "EMPLOYMENT_INCOME":
      return MortgageCategory_StepKey.EMPLOYMENT_INCOME;
    case 5:
    case "ASSETS":
      return MortgageCategory_StepKey.ASSETS;
    case 6:
    case "DECLARATIONS":
      return MortgageCategory_StepKey.DECLARATIONS;
    case 7:
    case "REVIEW_SUBMIT":
      return MortgageCategory_StepKey.REVIEW_SUBMIT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MortgageCategory_StepKey.UNRECOGNIZED;
  }
}

export function mortgageCategory_StepKeyToJSON(object: MortgageCategory_StepKey): string {
  switch (object) {
    case MortgageCategory_StepKey.UNKNOWN_STEP:
      return "UNKNOWN_STEP";
    case MortgageCategory_StepKey.VERIFICATION:
      return "VERIFICATION";
    case MortgageCategory_StepKey.ABOUT_YOU:
      return "ABOUT_YOU";
    case MortgageCategory_StepKey.REAL_ESTATE:
      return "REAL_ESTATE";
    case MortgageCategory_StepKey.EMPLOYMENT_INCOME:
      return "EMPLOYMENT_INCOME";
    case MortgageCategory_StepKey.ASSETS:
      return "ASSETS";
    case MortgageCategory_StepKey.DECLARATIONS:
      return "DECLARATIONS";
    case MortgageCategory_StepKey.REVIEW_SUBMIT:
      return "REVIEW_SUBMIT";
    case MortgageCategory_StepKey.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum MortgageCategory_EntrySource {
  UNKNOWN_ENTRY_SOURCE = 0,
  DIRECT = 1,
  MARKETING = 2,
  PARTNER = 3,
  REFERRAL = 4,
  UNRECOGNIZED = -1,
}

export function mortgageCategory_EntrySourceFromJSON(object: any): MortgageCategory_EntrySource {
  switch (object) {
    case 0:
    case "UNKNOWN_ENTRY_SOURCE":
      return MortgageCategory_EntrySource.UNKNOWN_ENTRY_SOURCE;
    case 1:
    case "DIRECT":
      return MortgageCategory_EntrySource.DIRECT;
    case 2:
    case "MARKETING":
      return MortgageCategory_EntrySource.MARKETING;
    case 3:
    case "PARTNER":
      return MortgageCategory_EntrySource.PARTNER;
    case 4:
    case "REFERRAL":
      return MortgageCategory_EntrySource.REFERRAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MortgageCategory_EntrySource.UNRECOGNIZED;
  }
}

export function mortgageCategory_EntrySourceToJSON(object: MortgageCategory_EntrySource): string {
  switch (object) {
    case MortgageCategory_EntrySource.UNKNOWN_ENTRY_SOURCE:
      return "UNKNOWN_ENTRY_SOURCE";
    case MortgageCategory_EntrySource.DIRECT:
      return "DIRECT";
    case MortgageCategory_EntrySource.MARKETING:
      return "MARKETING";
    case MortgageCategory_EntrySource.PARTNER:
      return "PARTNER";
    case MortgageCategory_EntrySource.REFERRAL:
      return "REFERRAL";
    case MortgageCategory_EntrySource.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum MortgageCategory_IntegrationType {
  UNKNOWN_INTEGRATION = 0,
  PLAID_LINK = 1,
  TRUV = 2,
  UNRECOGNIZED = -1,
}

export function mortgageCategory_IntegrationTypeFromJSON(object: any): MortgageCategory_IntegrationType {
  switch (object) {
    case 0:
    case "UNKNOWN_INTEGRATION":
      return MortgageCategory_IntegrationType.UNKNOWN_INTEGRATION;
    case 1:
    case "PLAID_LINK":
      return MortgageCategory_IntegrationType.PLAID_LINK;
    case 2:
    case "TRUV":
      return MortgageCategory_IntegrationType.TRUV;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MortgageCategory_IntegrationType.UNRECOGNIZED;
  }
}

export function mortgageCategory_IntegrationTypeToJSON(object: MortgageCategory_IntegrationType): string {
  switch (object) {
    case MortgageCategory_IntegrationType.UNKNOWN_INTEGRATION:
      return "UNKNOWN_INTEGRATION";
    case MortgageCategory_IntegrationType.PLAID_LINK:
      return "PLAID_LINK";
    case MortgageCategory_IntegrationType.TRUV:
      return "TRUV";
    case MortgageCategory_IntegrationType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum MortgageCategory_IntegrationResult {
  UNKNOWN_RESULT = 0,
  SUCCESS = 1,
  FAILED = 2,
  CANCELLED = 3,
  UNRECOGNIZED = -1,
}

export function mortgageCategory_IntegrationResultFromJSON(object: any): MortgageCategory_IntegrationResult {
  switch (object) {
    case 0:
    case "UNKNOWN_RESULT":
      return MortgageCategory_IntegrationResult.UNKNOWN_RESULT;
    case 1:
    case "SUCCESS":
      return MortgageCategory_IntegrationResult.SUCCESS;
    case 2:
    case "FAILED":
      return MortgageCategory_IntegrationResult.FAILED;
    case 3:
    case "CANCELLED":
      return MortgageCategory_IntegrationResult.CANCELLED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MortgageCategory_IntegrationResult.UNRECOGNIZED;
  }
}

export function mortgageCategory_IntegrationResultToJSON(object: MortgageCategory_IntegrationResult): string {
  switch (object) {
    case MortgageCategory_IntegrationResult.UNKNOWN_RESULT:
      return "UNKNOWN_RESULT";
    case MortgageCategory_IntegrationResult.SUCCESS:
      return "SUCCESS";
    case MortgageCategory_IntegrationResult.FAILED:
      return "FAILED";
    case MortgageCategory_IntegrationResult.CANCELLED:
      return "CANCELLED";
    case MortgageCategory_IntegrationResult.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum MortgageCategory_FailureReason {
  UNKNOWN_FAILURE = 0,
  USER_CANCELLED = 1,
  VERIFICATION_FAILED = 2,
  TIMEOUT = 3,
  ERROR = 4,
  INSTITUTION_ERROR = 5,
  EMPLOYER_NOT_FOUND = 6,
  UNRECOGNIZED = -1,
}

export function mortgageCategory_FailureReasonFromJSON(object: any): MortgageCategory_FailureReason {
  switch (object) {
    case 0:
    case "UNKNOWN_FAILURE":
      return MortgageCategory_FailureReason.UNKNOWN_FAILURE;
    case 1:
    case "USER_CANCELLED":
      return MortgageCategory_FailureReason.USER_CANCELLED;
    case 2:
    case "VERIFICATION_FAILED":
      return MortgageCategory_FailureReason.VERIFICATION_FAILED;
    case 3:
    case "TIMEOUT":
      return MortgageCategory_FailureReason.TIMEOUT;
    case 4:
    case "ERROR":
      return MortgageCategory_FailureReason.ERROR;
    case 5:
    case "INSTITUTION_ERROR":
      return MortgageCategory_FailureReason.INSTITUTION_ERROR;
    case 6:
    case "EMPLOYER_NOT_FOUND":
      return MortgageCategory_FailureReason.EMPLOYER_NOT_FOUND;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MortgageCategory_FailureReason.UNRECOGNIZED;
  }
}

export function mortgageCategory_FailureReasonToJSON(object: MortgageCategory_FailureReason): string {
  switch (object) {
    case MortgageCategory_FailureReason.UNKNOWN_FAILURE:
      return "UNKNOWN_FAILURE";
    case MortgageCategory_FailureReason.USER_CANCELLED:
      return "USER_CANCELLED";
    case MortgageCategory_FailureReason.VERIFICATION_FAILED:
      return "VERIFICATION_FAILED";
    case MortgageCategory_FailureReason.TIMEOUT:
      return "TIMEOUT";
    case MortgageCategory_FailureReason.ERROR:
      return "ERROR";
    case MortgageCategory_FailureReason.INSTITUTION_ERROR:
      return "INSTITUTION_ERROR";
    case MortgageCategory_FailureReason.EMPLOYER_NOT_FOUND:
      return "EMPLOYER_NOT_FOUND";
    case MortgageCategory_FailureReason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum MortgageCategory_ValidationErrorType {
  UNKNOWN_ERROR_TYPE = 0,
  REQUIRED = 1,
  FORMAT = 2,
  RANGE = 3,
  CUSTOM = 4,
  UNRECOGNIZED = -1,
}

export function mortgageCategory_ValidationErrorTypeFromJSON(object: any): MortgageCategory_ValidationErrorType {
  switch (object) {
    case 0:
    case "UNKNOWN_ERROR_TYPE":
      return MortgageCategory_ValidationErrorType.UNKNOWN_ERROR_TYPE;
    case 1:
    case "REQUIRED":
      return MortgageCategory_ValidationErrorType.REQUIRED;
    case 2:
    case "FORMAT":
      return MortgageCategory_ValidationErrorType.FORMAT;
    case 3:
    case "RANGE":
      return MortgageCategory_ValidationErrorType.RANGE;
    case 4:
    case "CUSTOM":
      return MortgageCategory_ValidationErrorType.CUSTOM;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MortgageCategory_ValidationErrorType.UNRECOGNIZED;
  }
}

export function mortgageCategory_ValidationErrorTypeToJSON(object: MortgageCategory_ValidationErrorType): string {
  switch (object) {
    case MortgageCategory_ValidationErrorType.UNKNOWN_ERROR_TYPE:
      return "UNKNOWN_ERROR_TYPE";
    case MortgageCategory_ValidationErrorType.REQUIRED:
      return "REQUIRED";
    case MortgageCategory_ValidationErrorType.FORMAT:
      return "FORMAT";
    case MortgageCategory_ValidationErrorType.RANGE:
      return "RANGE";
    case MortgageCategory_ValidationErrorType.CUSTOM:
      return "CUSTOM";
    case MortgageCategory_ValidationErrorType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum MortgageCategory_DecisionType {
  UNKNOWN_DECISION = 0,
  APPROVED = 1,
  REJECTED = 2,
  UNRECOGNIZED = -1,
}

export function mortgageCategory_DecisionTypeFromJSON(object: any): MortgageCategory_DecisionType {
  switch (object) {
    case 0:
    case "UNKNOWN_DECISION":
      return MortgageCategory_DecisionType.UNKNOWN_DECISION;
    case 1:
    case "APPROVED":
      return MortgageCategory_DecisionType.APPROVED;
    case 2:
    case "REJECTED":
      return MortgageCategory_DecisionType.REJECTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MortgageCategory_DecisionType.UNRECOGNIZED;
  }
}

export function mortgageCategory_DecisionTypeToJSON(object: MortgageCategory_DecisionType): string {
  switch (object) {
    case MortgageCategory_DecisionType.UNKNOWN_DECISION:
      return "UNKNOWN_DECISION";
    case MortgageCategory_DecisionType.APPROVED:
      return "APPROVED";
    case MortgageCategory_DecisionType.REJECTED:
      return "REJECTED";
    case MortgageCategory_DecisionType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum MortgageCategory_PrequalStepKey {
  PREQUAL_UNKNOWN_STEP = 0,
  PREQUAL_LOCATION = 1,
  PREQUAL_PURCHASE_PRICE = 2,
  PREQUAL_DOWN_PAYMENT = 3,
  PREQUAL_ANNUAL_INCOME = 4,
  PREQUAL_MONTHLY_DEBT = 5,
  PREQUAL_CREDIT_SCORE = 6,
  PREQUAL_PHONE_NUMBER = 7,
  PREQUAL_HOME_USAGE = 8,
  PREQUAL_PURCHASE_TIMELINE = 9,
  PREQUAL_EMPLOYMENT_STATUS = 10,
  PREQUAL_CURRENT_ADDRESS = 11,
  PREQUAL_CO_BORROWER = 12,
  PREQUAL_CLOSING_DATE = 13,
  UNRECOGNIZED = -1,
}

export function mortgageCategory_PrequalStepKeyFromJSON(object: any): MortgageCategory_PrequalStepKey {
  switch (object) {
    case 0:
    case "PREQUAL_UNKNOWN_STEP":
      return MortgageCategory_PrequalStepKey.PREQUAL_UNKNOWN_STEP;
    case 1:
    case "PREQUAL_LOCATION":
      return MortgageCategory_PrequalStepKey.PREQUAL_LOCATION;
    case 2:
    case "PREQUAL_PURCHASE_PRICE":
      return MortgageCategory_PrequalStepKey.PREQUAL_PURCHASE_PRICE;
    case 3:
    case "PREQUAL_DOWN_PAYMENT":
      return MortgageCategory_PrequalStepKey.PREQUAL_DOWN_PAYMENT;
    case 4:
    case "PREQUAL_ANNUAL_INCOME":
      return MortgageCategory_PrequalStepKey.PREQUAL_ANNUAL_INCOME;
    case 5:
    case "PREQUAL_MONTHLY_DEBT":
      return MortgageCategory_PrequalStepKey.PREQUAL_MONTHLY_DEBT;
    case 6:
    case "PREQUAL_CREDIT_SCORE":
      return MortgageCategory_PrequalStepKey.PREQUAL_CREDIT_SCORE;
    case 7:
    case "PREQUAL_PHONE_NUMBER":
      return MortgageCategory_PrequalStepKey.PREQUAL_PHONE_NUMBER;
    case 8:
    case "PREQUAL_HOME_USAGE":
      return MortgageCategory_PrequalStepKey.PREQUAL_HOME_USAGE;
    case 9:
    case "PREQUAL_PURCHASE_TIMELINE":
      return MortgageCategory_PrequalStepKey.PREQUAL_PURCHASE_TIMELINE;
    case 10:
    case "PREQUAL_EMPLOYMENT_STATUS":
      return MortgageCategory_PrequalStepKey.PREQUAL_EMPLOYMENT_STATUS;
    case 11:
    case "PREQUAL_CURRENT_ADDRESS":
      return MortgageCategory_PrequalStepKey.PREQUAL_CURRENT_ADDRESS;
    case 12:
    case "PREQUAL_CO_BORROWER":
      return MortgageCategory_PrequalStepKey.PREQUAL_CO_BORROWER;
    case 13:
    case "PREQUAL_CLOSING_DATE":
      return MortgageCategory_PrequalStepKey.PREQUAL_CLOSING_DATE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MortgageCategory_PrequalStepKey.UNRECOGNIZED;
  }
}

export function mortgageCategory_PrequalStepKeyToJSON(object: MortgageCategory_PrequalStepKey): string {
  switch (object) {
    case MortgageCategory_PrequalStepKey.PREQUAL_UNKNOWN_STEP:
      return "PREQUAL_UNKNOWN_STEP";
    case MortgageCategory_PrequalStepKey.PREQUAL_LOCATION:
      return "PREQUAL_LOCATION";
    case MortgageCategory_PrequalStepKey.PREQUAL_PURCHASE_PRICE:
      return "PREQUAL_PURCHASE_PRICE";
    case MortgageCategory_PrequalStepKey.PREQUAL_DOWN_PAYMENT:
      return "PREQUAL_DOWN_PAYMENT";
    case MortgageCategory_PrequalStepKey.PREQUAL_ANNUAL_INCOME:
      return "PREQUAL_ANNUAL_INCOME";
    case MortgageCategory_PrequalStepKey.PREQUAL_MONTHLY_DEBT:
      return "PREQUAL_MONTHLY_DEBT";
    case MortgageCategory_PrequalStepKey.PREQUAL_CREDIT_SCORE:
      return "PREQUAL_CREDIT_SCORE";
    case MortgageCategory_PrequalStepKey.PREQUAL_PHONE_NUMBER:
      return "PREQUAL_PHONE_NUMBER";
    case MortgageCategory_PrequalStepKey.PREQUAL_HOME_USAGE:
      return "PREQUAL_HOME_USAGE";
    case MortgageCategory_PrequalStepKey.PREQUAL_PURCHASE_TIMELINE:
      return "PREQUAL_PURCHASE_TIMELINE";
    case MortgageCategory_PrequalStepKey.PREQUAL_EMPLOYMENT_STATUS:
      return "PREQUAL_EMPLOYMENT_STATUS";
    case MortgageCategory_PrequalStepKey.PREQUAL_CURRENT_ADDRESS:
      return "PREQUAL_CURRENT_ADDRESS";
    case MortgageCategory_PrequalStepKey.PREQUAL_CO_BORROWER:
      return "PREQUAL_CO_BORROWER";
    case MortgageCategory_PrequalStepKey.PREQUAL_CLOSING_DATE:
      return "PREQUAL_CLOSING_DATE";
    case MortgageCategory_PrequalStepKey.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum MortgageCategory_PrequalChannel {
  UNKNOWN_CHANNEL = 0,
  BUYER_CHECKOUT = 1,
  LISTING_PARTNER_LINK = 2,
  UNRECOGNIZED = -1,
}

export function mortgageCategory_PrequalChannelFromJSON(object: any): MortgageCategory_PrequalChannel {
  switch (object) {
    case 0:
    case "UNKNOWN_CHANNEL":
      return MortgageCategory_PrequalChannel.UNKNOWN_CHANNEL;
    case 1:
    case "BUYER_CHECKOUT":
      return MortgageCategory_PrequalChannel.BUYER_CHECKOUT;
    case 2:
    case "LISTING_PARTNER_LINK":
      return MortgageCategory_PrequalChannel.LISTING_PARTNER_LINK;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MortgageCategory_PrequalChannel.UNRECOGNIZED;
  }
}

export function mortgageCategory_PrequalChannelToJSON(object: MortgageCategory_PrequalChannel): string {
  switch (object) {
    case MortgageCategory_PrequalChannel.UNKNOWN_CHANNEL:
      return "UNKNOWN_CHANNEL";
    case MortgageCategory_PrequalChannel.BUYER_CHECKOUT:
      return "BUYER_CHECKOUT";
    case MortgageCategory_PrequalChannel.LISTING_PARTNER_LINK:
      return "LISTING_PARTNER_LINK";
    case MortgageCategory_PrequalChannel.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum MortgageCategory_PrequalDecisionType {
  PREQUAL_UNKNOWN_DECISION = 0,
  PREQUAL_APPROVED = 1,
  PREQUAL_DECLINED = 2,
  PREQUAL_DISQUALIFIED = 3,
  PREQUAL_TIMED_OUT = 4,
  UNRECOGNIZED = -1,
}

export function mortgageCategory_PrequalDecisionTypeFromJSON(object: any): MortgageCategory_PrequalDecisionType {
  switch (object) {
    case 0:
    case "PREQUAL_UNKNOWN_DECISION":
      return MortgageCategory_PrequalDecisionType.PREQUAL_UNKNOWN_DECISION;
    case 1:
    case "PREQUAL_APPROVED":
      return MortgageCategory_PrequalDecisionType.PREQUAL_APPROVED;
    case 2:
    case "PREQUAL_DECLINED":
      return MortgageCategory_PrequalDecisionType.PREQUAL_DECLINED;
    case 3:
    case "PREQUAL_DISQUALIFIED":
      return MortgageCategory_PrequalDecisionType.PREQUAL_DISQUALIFIED;
    case 4:
    case "PREQUAL_TIMED_OUT":
      return MortgageCategory_PrequalDecisionType.PREQUAL_TIMED_OUT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MortgageCategory_PrequalDecisionType.UNRECOGNIZED;
  }
}

export function mortgageCategory_PrequalDecisionTypeToJSON(object: MortgageCategory_PrequalDecisionType): string {
  switch (object) {
    case MortgageCategory_PrequalDecisionType.PREQUAL_UNKNOWN_DECISION:
      return "PREQUAL_UNKNOWN_DECISION";
    case MortgageCategory_PrequalDecisionType.PREQUAL_APPROVED:
      return "PREQUAL_APPROVED";
    case MortgageCategory_PrequalDecisionType.PREQUAL_DECLINED:
      return "PREQUAL_DECLINED";
    case MortgageCategory_PrequalDecisionType.PREQUAL_DISQUALIFIED:
      return "PREQUAL_DISQUALIFIED";
    case MortgageCategory_PrequalDecisionType.PREQUAL_TIMED_OUT:
      return "PREQUAL_TIMED_OUT";
    case MortgageCategory_PrequalDecisionType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Fired when user lands on the application for the first time
 * Next ID: 4
 */
export interface MortgageCategory_ApplicationStartEvent {
  loanUuid: string;
  /** borrower_uuid is the customer/applicant identifier */
  borrowerUuid: string;
  entrySource: MortgageCategory_EntrySource;
}

/**
 * Fired when user navigates to a step (including returns)
 * Next ID: 6
 */
export interface MortgageCategory_StepViewEvent {
  loanUuid: string;
  borrowerUuid: string;
  stepKey: MortgageCategory_StepKey;
  isFirstView: boolean;
  isReturnVisit: boolean;
}

/**
 * Fired when user successfully advances to the next step
 * Next ID: 7
 */
export interface MortgageCategory_StepCompleteEvent {
  loanUuid: string;
  borrowerUuid: string;
  stepKey: MortgageCategory_StepKey;
  durationMs: number;
  integrationType: MortgageCategory_IntegrationType;
  integrationSuccess?: boolean | undefined;
}

/**
 * Fired when user clicks submit on Review step
 * Next ID: 5
 */
export interface MortgageCategory_ApplicationSubmitEvent {
  loanUuid: string;
  borrowerUuid: string;
  totalDurationMs: number;
  integrationsUsed: MortgageCategory_IntegrationType[];
}

/**
 * Fired when backend returns application decision
 * Next ID: 5
 */
export interface MortgageCategory_ApplicationDecisionEvent {
  loanUuid: string;
  borrowerUuid: string;
  timeToDecisionMs: number;
  decisionType: MortgageCategory_DecisionType;
}

/**
 * Fired when an integration modal opens (Plaid Link, Truv, etc.)
 * Next ID: 4
 */
export interface MortgageCategory_IntegrationStartEvent {
  loanUuid: string;
  borrowerUuid: string;
  integrationType: MortgageCategory_IntegrationType;
}

/**
 * Fired when an integration completes (success, failure, or cancellation)
 * Next ID: 7
 */
export interface MortgageCategory_IntegrationResultEvent {
  loanUuid: string;
  borrowerUuid: string;
  integrationType: MortgageCategory_IntegrationType;
  result: MortgageCategory_IntegrationResult;
  durationMs: number;
  failureReason: MortgageCategory_FailureReason;
}

/**
 * Fired when user enters the product pricing flow (after selecting down payment)
 * Next ID: 5
 */
export interface MortgageCategory_ProductPricingStartEvent {
  loanUuid: string;
  borrowerUuid: string;
  downPaymentPercent: number;
  optionsCount: number;
}

/**
 * Fired when user sets or changes their out-of-pocket maximum
 * Next ID: 4
 */
export interface MortgageCategory_OutOfPocketMaxSelectionEvent {
  loanUuid: string;
  borrowerUuid: string;
  outOfPocketMaxCents: number;
}

/**
 * Fired when user selects or changes down payment percentage
 * Next ID: 5
 */
export interface MortgageCategory_DownPaymentSelectionEvent {
  loanUuid: string;
  borrowerUuid: string;
  downPaymentPercent: number;
  isCustom: boolean;
}

/**
 * Fired when user selects a rate option
 * Next ID: 6
 */
export interface MortgageCategory_ProductPricingSelectEvent {
  loanUuid: string;
  borrowerUuid: string;
  ratePercent: string;
  lockPeriodDays: number;
  monthlyPaymentCents: number;
}

/**
 * Fired when user clicks "View details" on a rate option
 * Next ID: 4
 */
export interface MortgageCategory_ProductPricingSeeDetailsEvent {
  loanUuid: string;
  borrowerUuid: string;
  ratePercent: string;
}

/**
 * Fired when user initiates rate lock (clicks "Lock my rate")
 * Next ID: 5
 */
export interface MortgageCategory_RateLockStartEvent {
  loanUuid: string;
  borrowerUuid: string;
  ratePercent: string;
  lockPeriodDays: number;
}

/**
 * Fired when rate lock is successfully completed
 * Next ID: 7
 */
export interface MortgageCategory_RateLockCompleteEvent {
  loanUuid: string;
  borrowerUuid: string;
  ratePercent: string;
  downPaymentPercent: number;
  monthlyPaymentCents: number;
  cashToCloseCents: number;
}

/**
 * Fired when user signs disclosures
 * Next ID: 3
 */
export interface MortgageCategory_DisclosuresSignedEvent {
  loanUuid: string;
  borrowerUuid: string;
}

/**
 * Fired when form validation fails
 * Next ID: 6
 */
export interface MortgageCategory_ValidationErrorEvent {
  loanUuid: string;
  borrowerUuid: string;
  stepKey: MortgageCategory_StepKey;
  fieldName: string;
  errorType: MortgageCategory_ValidationErrorType;
}

/**
 * Fired when user starts the prequal flow (title screen shown or landing page loaded)
 * Next ID: 5
 */
export interface MortgageCategory_PrequalStartEvent {
  prequalApplicationId: string;
  customerUuid?: string | undefined;
  prequalChannel: MortgageCategory_PrequalChannel;
  prequalLinkId?: string | undefined;
}

/**
 * Fired when user navigates to a prequal question step
 * Next ID: 6
 */
export interface MortgageCategory_PrequalStepViewEvent {
  prequalApplicationId: string;
  customerUuid?: string | undefined;
  stepKey: MortgageCategory_PrequalStepKey;
  isFirstView: boolean;
  isReturnVisit: boolean;
}

/**
 * Fired when user successfully advances past a prequal step
 * Next ID: 5
 */
export interface MortgageCategory_PrequalStepCompleteEvent {
  prequalApplicationId: string;
  customerUuid?: string | undefined;
  stepKey: MortgageCategory_PrequalStepKey;
  durationMs: number;
}

/**
 * Fired when user submits the completed prequal form
 * Next ID: 6
 */
export interface MortgageCategory_PrequalSubmitEvent {
  prequalApplicationId: string;
  customerUuid?: string | undefined;
  totalDurationMs: number;
  prequalChannel: MortgageCategory_PrequalChannel;
  stepsCompleted: number;
}

/**
 * Fired when backend returns the prequal decision
 * Next ID: 7
 */
export interface MortgageCategory_PrequalDecisionEvent {
  prequalApplicationId: string;
  customerUuid?: string | undefined;
  timeToDecisionMs: number;
  decisionType: MortgageCategory_PrequalDecisionType;
  maxLoanAmountCents?: number | undefined;
  ratePercent?: string | undefined;
}

/**
 * Fired when user is referred to Lower.com (checkout flow disqualification path)
 * Next ID: 5
 */
export interface MortgageCategory_LowerReferralEvent {
  prequalApplicationId: string;
  customerUuid?: string | undefined;
  success: boolean;
  referralReason: MortgageCategory_PrequalDecisionType;
}

/**
 * Fired when form validation fails on a prequal step
 * Next ID: 6
 */
export interface MortgageCategory_PrequalValidationErrorEvent {
  prequalApplicationId: string;
  customerUuid?: string | undefined;
  stepKey: MortgageCategory_PrequalStepKey;
  fieldName: string;
  errorType: MortgageCategory_ValidationErrorType;
}

function createBaseMortgageCategory(): MortgageCategory {
  return { event: undefined };
}

export const MortgageCategory = {
  fromJSON(object: any): MortgageCategory {
    return {
      event: isSet(object.applicationStart)
        ? {
          $case: "applicationStart",
          applicationStart: MortgageCategory_ApplicationStartEvent.fromJSON(object.applicationStart),
        }
        : isSet(object.stepView)
        ? { $case: "stepView", stepView: MortgageCategory_StepViewEvent.fromJSON(object.stepView) }
        : isSet(object.stepComplete)
        ? { $case: "stepComplete", stepComplete: MortgageCategory_StepCompleteEvent.fromJSON(object.stepComplete) }
        : isSet(object.applicationSubmit)
        ? {
          $case: "applicationSubmit",
          applicationSubmit: MortgageCategory_ApplicationSubmitEvent.fromJSON(object.applicationSubmit),
        }
        : isSet(object.applicationDecision)
        ? {
          $case: "applicationDecision",
          applicationDecision: MortgageCategory_ApplicationDecisionEvent.fromJSON(object.applicationDecision),
        }
        : isSet(object.integrationStart)
        ? {
          $case: "integrationStart",
          integrationStart: MortgageCategory_IntegrationStartEvent.fromJSON(object.integrationStart),
        }
        : isSet(object.integrationResult)
        ? {
          $case: "integrationResult",
          integrationResult: MortgageCategory_IntegrationResultEvent.fromJSON(object.integrationResult),
        }
        : isSet(object.productPricingStart)
        ? {
          $case: "productPricingStart",
          productPricingStart: MortgageCategory_ProductPricingStartEvent.fromJSON(object.productPricingStart),
        }
        : isSet(object.outOfPocketMaxSelection)
        ? {
          $case: "outOfPocketMaxSelection",
          outOfPocketMaxSelection: MortgageCategory_OutOfPocketMaxSelectionEvent.fromJSON(
            object.outOfPocketMaxSelection,
          ),
        }
        : isSet(object.downPaymentSelection)
        ? {
          $case: "downPaymentSelection",
          downPaymentSelection: MortgageCategory_DownPaymentSelectionEvent.fromJSON(object.downPaymentSelection),
        }
        : isSet(object.productPricingSelect)
        ? {
          $case: "productPricingSelect",
          productPricingSelect: MortgageCategory_ProductPricingSelectEvent.fromJSON(object.productPricingSelect),
        }
        : isSet(object.productPricingSeeDetails)
        ? {
          $case: "productPricingSeeDetails",
          productPricingSeeDetails: MortgageCategory_ProductPricingSeeDetailsEvent.fromJSON(
            object.productPricingSeeDetails,
          ),
        }
        : isSet(object.rateLockStart)
        ? { $case: "rateLockStart", rateLockStart: MortgageCategory_RateLockStartEvent.fromJSON(object.rateLockStart) }
        : isSet(object.rateLockComplete)
        ? {
          $case: "rateLockComplete",
          rateLockComplete: MortgageCategory_RateLockCompleteEvent.fromJSON(object.rateLockComplete),
        }
        : isSet(object.disclosuresSigned)
        ? {
          $case: "disclosuresSigned",
          disclosuresSigned: MortgageCategory_DisclosuresSignedEvent.fromJSON(object.disclosuresSigned),
        }
        : isSet(object.validationError)
        ? {
          $case: "validationError",
          validationError: MortgageCategory_ValidationErrorEvent.fromJSON(object.validationError),
        }
        : isSet(object.prequalStart)
        ? { $case: "prequalStart", prequalStart: MortgageCategory_PrequalStartEvent.fromJSON(object.prequalStart) }
        : isSet(object.prequalStepView)
        ? {
          $case: "prequalStepView",
          prequalStepView: MortgageCategory_PrequalStepViewEvent.fromJSON(object.prequalStepView),
        }
        : isSet(object.prequalStepComplete)
        ? {
          $case: "prequalStepComplete",
          prequalStepComplete: MortgageCategory_PrequalStepCompleteEvent.fromJSON(object.prequalStepComplete),
        }
        : isSet(object.prequalSubmit)
        ? { $case: "prequalSubmit", prequalSubmit: MortgageCategory_PrequalSubmitEvent.fromJSON(object.prequalSubmit) }
        : isSet(object.prequalDecision)
        ? {
          $case: "prequalDecision",
          prequalDecision: MortgageCategory_PrequalDecisionEvent.fromJSON(object.prequalDecision),
        }
        : isSet(object.lowerReferral)
        ? { $case: "lowerReferral", lowerReferral: MortgageCategory_LowerReferralEvent.fromJSON(object.lowerReferral) }
        : isSet(object.prequalValidationError)
        ? {
          $case: "prequalValidationError",
          prequalValidationError: MortgageCategory_PrequalValidationErrorEvent.fromJSON(object.prequalValidationError),
        }
        : undefined,
    };
  },

  toJSON(message: MortgageCategory): unknown {
    const obj: any = {};
    if (message.event?.$case === "applicationStart") {
      obj.applicationStart = MortgageCategory_ApplicationStartEvent.toJSON(message.event.applicationStart);
    }
    if (message.event?.$case === "stepView") {
      obj.stepView = MortgageCategory_StepViewEvent.toJSON(message.event.stepView);
    }
    if (message.event?.$case === "stepComplete") {
      obj.stepComplete = MortgageCategory_StepCompleteEvent.toJSON(message.event.stepComplete);
    }
    if (message.event?.$case === "applicationSubmit") {
      obj.applicationSubmit = MortgageCategory_ApplicationSubmitEvent.toJSON(message.event.applicationSubmit);
    }
    if (message.event?.$case === "applicationDecision") {
      obj.applicationDecision = MortgageCategory_ApplicationDecisionEvent.toJSON(message.event.applicationDecision);
    }
    if (message.event?.$case === "integrationStart") {
      obj.integrationStart = MortgageCategory_IntegrationStartEvent.toJSON(message.event.integrationStart);
    }
    if (message.event?.$case === "integrationResult") {
      obj.integrationResult = MortgageCategory_IntegrationResultEvent.toJSON(message.event.integrationResult);
    }
    if (message.event?.$case === "productPricingStart") {
      obj.productPricingStart = MortgageCategory_ProductPricingStartEvent.toJSON(message.event.productPricingStart);
    }
    if (message.event?.$case === "outOfPocketMaxSelection") {
      obj.outOfPocketMaxSelection = MortgageCategory_OutOfPocketMaxSelectionEvent.toJSON(
        message.event.outOfPocketMaxSelection,
      );
    }
    if (message.event?.$case === "downPaymentSelection") {
      obj.downPaymentSelection = MortgageCategory_DownPaymentSelectionEvent.toJSON(message.event.downPaymentSelection);
    }
    if (message.event?.$case === "productPricingSelect") {
      obj.productPricingSelect = MortgageCategory_ProductPricingSelectEvent.toJSON(message.event.productPricingSelect);
    }
    if (message.event?.$case === "productPricingSeeDetails") {
      obj.productPricingSeeDetails = MortgageCategory_ProductPricingSeeDetailsEvent.toJSON(
        message.event.productPricingSeeDetails,
      );
    }
    if (message.event?.$case === "rateLockStart") {
      obj.rateLockStart = MortgageCategory_RateLockStartEvent.toJSON(message.event.rateLockStart);
    }
    if (message.event?.$case === "rateLockComplete") {
      obj.rateLockComplete = MortgageCategory_RateLockCompleteEvent.toJSON(message.event.rateLockComplete);
    }
    if (message.event?.$case === "disclosuresSigned") {
      obj.disclosuresSigned = MortgageCategory_DisclosuresSignedEvent.toJSON(message.event.disclosuresSigned);
    }
    if (message.event?.$case === "validationError") {
      obj.validationError = MortgageCategory_ValidationErrorEvent.toJSON(message.event.validationError);
    }
    if (message.event?.$case === "prequalStart") {
      obj.prequalStart = MortgageCategory_PrequalStartEvent.toJSON(message.event.prequalStart);
    }
    if (message.event?.$case === "prequalStepView") {
      obj.prequalStepView = MortgageCategory_PrequalStepViewEvent.toJSON(message.event.prequalStepView);
    }
    if (message.event?.$case === "prequalStepComplete") {
      obj.prequalStepComplete = MortgageCategory_PrequalStepCompleteEvent.toJSON(message.event.prequalStepComplete);
    }
    if (message.event?.$case === "prequalSubmit") {
      obj.prequalSubmit = MortgageCategory_PrequalSubmitEvent.toJSON(message.event.prequalSubmit);
    }
    if (message.event?.$case === "prequalDecision") {
      obj.prequalDecision = MortgageCategory_PrequalDecisionEvent.toJSON(message.event.prequalDecision);
    }
    if (message.event?.$case === "lowerReferral") {
      obj.lowerReferral = MortgageCategory_LowerReferralEvent.toJSON(message.event.lowerReferral);
    }
    if (message.event?.$case === "prequalValidationError") {
      obj.prequalValidationError = MortgageCategory_PrequalValidationErrorEvent.toJSON(
        message.event.prequalValidationError,
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory>, I>>(base?: I): MortgageCategory {
    return MortgageCategory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory>, I>>(object: I): MortgageCategory {
    const message = createBaseMortgageCategory();
    if (
      object.event?.$case === "applicationStart" &&
      object.event?.applicationStart !== undefined &&
      object.event?.applicationStart !== null
    ) {
      message.event = {
        $case: "applicationStart",
        applicationStart: MortgageCategory_ApplicationStartEvent.fromPartial(object.event.applicationStart),
      };
    }
    if (object.event?.$case === "stepView" && object.event?.stepView !== undefined && object.event?.stepView !== null) {
      message.event = {
        $case: "stepView",
        stepView: MortgageCategory_StepViewEvent.fromPartial(object.event.stepView),
      };
    }
    if (
      object.event?.$case === "stepComplete" &&
      object.event?.stepComplete !== undefined &&
      object.event?.stepComplete !== null
    ) {
      message.event = {
        $case: "stepComplete",
        stepComplete: MortgageCategory_StepCompleteEvent.fromPartial(object.event.stepComplete),
      };
    }
    if (
      object.event?.$case === "applicationSubmit" &&
      object.event?.applicationSubmit !== undefined &&
      object.event?.applicationSubmit !== null
    ) {
      message.event = {
        $case: "applicationSubmit",
        applicationSubmit: MortgageCategory_ApplicationSubmitEvent.fromPartial(object.event.applicationSubmit),
      };
    }
    if (
      object.event?.$case === "applicationDecision" &&
      object.event?.applicationDecision !== undefined &&
      object.event?.applicationDecision !== null
    ) {
      message.event = {
        $case: "applicationDecision",
        applicationDecision: MortgageCategory_ApplicationDecisionEvent.fromPartial(object.event.applicationDecision),
      };
    }
    if (
      object.event?.$case === "integrationStart" &&
      object.event?.integrationStart !== undefined &&
      object.event?.integrationStart !== null
    ) {
      message.event = {
        $case: "integrationStart",
        integrationStart: MortgageCategory_IntegrationStartEvent.fromPartial(object.event.integrationStart),
      };
    }
    if (
      object.event?.$case === "integrationResult" &&
      object.event?.integrationResult !== undefined &&
      object.event?.integrationResult !== null
    ) {
      message.event = {
        $case: "integrationResult",
        integrationResult: MortgageCategory_IntegrationResultEvent.fromPartial(object.event.integrationResult),
      };
    }
    if (
      object.event?.$case === "productPricingStart" &&
      object.event?.productPricingStart !== undefined &&
      object.event?.productPricingStart !== null
    ) {
      message.event = {
        $case: "productPricingStart",
        productPricingStart: MortgageCategory_ProductPricingStartEvent.fromPartial(object.event.productPricingStart),
      };
    }
    if (
      object.event?.$case === "outOfPocketMaxSelection" &&
      object.event?.outOfPocketMaxSelection !== undefined &&
      object.event?.outOfPocketMaxSelection !== null
    ) {
      message.event = {
        $case: "outOfPocketMaxSelection",
        outOfPocketMaxSelection: MortgageCategory_OutOfPocketMaxSelectionEvent.fromPartial(
          object.event.outOfPocketMaxSelection,
        ),
      };
    }
    if (
      object.event?.$case === "downPaymentSelection" &&
      object.event?.downPaymentSelection !== undefined &&
      object.event?.downPaymentSelection !== null
    ) {
      message.event = {
        $case: "downPaymentSelection",
        downPaymentSelection: MortgageCategory_DownPaymentSelectionEvent.fromPartial(object.event.downPaymentSelection),
      };
    }
    if (
      object.event?.$case === "productPricingSelect" &&
      object.event?.productPricingSelect !== undefined &&
      object.event?.productPricingSelect !== null
    ) {
      message.event = {
        $case: "productPricingSelect",
        productPricingSelect: MortgageCategory_ProductPricingSelectEvent.fromPartial(object.event.productPricingSelect),
      };
    }
    if (
      object.event?.$case === "productPricingSeeDetails" &&
      object.event?.productPricingSeeDetails !== undefined &&
      object.event?.productPricingSeeDetails !== null
    ) {
      message.event = {
        $case: "productPricingSeeDetails",
        productPricingSeeDetails: MortgageCategory_ProductPricingSeeDetailsEvent.fromPartial(
          object.event.productPricingSeeDetails,
        ),
      };
    }
    if (
      object.event?.$case === "rateLockStart" &&
      object.event?.rateLockStart !== undefined &&
      object.event?.rateLockStart !== null
    ) {
      message.event = {
        $case: "rateLockStart",
        rateLockStart: MortgageCategory_RateLockStartEvent.fromPartial(object.event.rateLockStart),
      };
    }
    if (
      object.event?.$case === "rateLockComplete" &&
      object.event?.rateLockComplete !== undefined &&
      object.event?.rateLockComplete !== null
    ) {
      message.event = {
        $case: "rateLockComplete",
        rateLockComplete: MortgageCategory_RateLockCompleteEvent.fromPartial(object.event.rateLockComplete),
      };
    }
    if (
      object.event?.$case === "disclosuresSigned" &&
      object.event?.disclosuresSigned !== undefined &&
      object.event?.disclosuresSigned !== null
    ) {
      message.event = {
        $case: "disclosuresSigned",
        disclosuresSigned: MortgageCategory_DisclosuresSignedEvent.fromPartial(object.event.disclosuresSigned),
      };
    }
    if (
      object.event?.$case === "validationError" &&
      object.event?.validationError !== undefined &&
      object.event?.validationError !== null
    ) {
      message.event = {
        $case: "validationError",
        validationError: MortgageCategory_ValidationErrorEvent.fromPartial(object.event.validationError),
      };
    }
    if (
      object.event?.$case === "prequalStart" &&
      object.event?.prequalStart !== undefined &&
      object.event?.prequalStart !== null
    ) {
      message.event = {
        $case: "prequalStart",
        prequalStart: MortgageCategory_PrequalStartEvent.fromPartial(object.event.prequalStart),
      };
    }
    if (
      object.event?.$case === "prequalStepView" &&
      object.event?.prequalStepView !== undefined &&
      object.event?.prequalStepView !== null
    ) {
      message.event = {
        $case: "prequalStepView",
        prequalStepView: MortgageCategory_PrequalStepViewEvent.fromPartial(object.event.prequalStepView),
      };
    }
    if (
      object.event?.$case === "prequalStepComplete" &&
      object.event?.prequalStepComplete !== undefined &&
      object.event?.prequalStepComplete !== null
    ) {
      message.event = {
        $case: "prequalStepComplete",
        prequalStepComplete: MortgageCategory_PrequalStepCompleteEvent.fromPartial(object.event.prequalStepComplete),
      };
    }
    if (
      object.event?.$case === "prequalSubmit" &&
      object.event?.prequalSubmit !== undefined &&
      object.event?.prequalSubmit !== null
    ) {
      message.event = {
        $case: "prequalSubmit",
        prequalSubmit: MortgageCategory_PrequalSubmitEvent.fromPartial(object.event.prequalSubmit),
      };
    }
    if (
      object.event?.$case === "prequalDecision" &&
      object.event?.prequalDecision !== undefined &&
      object.event?.prequalDecision !== null
    ) {
      message.event = {
        $case: "prequalDecision",
        prequalDecision: MortgageCategory_PrequalDecisionEvent.fromPartial(object.event.prequalDecision),
      };
    }
    if (
      object.event?.$case === "lowerReferral" &&
      object.event?.lowerReferral !== undefined &&
      object.event?.lowerReferral !== null
    ) {
      message.event = {
        $case: "lowerReferral",
        lowerReferral: MortgageCategory_LowerReferralEvent.fromPartial(object.event.lowerReferral),
      };
    }
    if (
      object.event?.$case === "prequalValidationError" &&
      object.event?.prequalValidationError !== undefined &&
      object.event?.prequalValidationError !== null
    ) {
      message.event = {
        $case: "prequalValidationError",
        prequalValidationError: MortgageCategory_PrequalValidationErrorEvent.fromPartial(
          object.event.prequalValidationError,
        ),
      };
    }
    return message;
  },
};

function createBaseMortgageCategory_ApplicationStartEvent(): MortgageCategory_ApplicationStartEvent {
  return { loanUuid: "", borrowerUuid: "", entrySource: 0 };
}

export const MortgageCategory_ApplicationStartEvent = {
  fromJSON(object: any): MortgageCategory_ApplicationStartEvent {
    return {
      loanUuid: isSet(object.loanUuid) ? String(object.loanUuid) : "",
      borrowerUuid: isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
      entrySource: isSet(object.entrySource) ? mortgageCategory_EntrySourceFromJSON(object.entrySource) : 0,
    };
  },

  toJSON(message: MortgageCategory_ApplicationStartEvent): unknown {
    const obj: any = {};
    if (message.loanUuid !== "") {
      obj.loanUuid = message.loanUuid;
    }
    if (message.borrowerUuid !== "") {
      obj.borrowerUuid = message.borrowerUuid;
    }
    if (message.entrySource !== 0) {
      obj.entrySource = mortgageCategory_EntrySourceToJSON(message.entrySource);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_ApplicationStartEvent>, I>>(
    base?: I,
  ): MortgageCategory_ApplicationStartEvent {
    return MortgageCategory_ApplicationStartEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_ApplicationStartEvent>, I>>(
    object: I,
  ): MortgageCategory_ApplicationStartEvent {
    const message = createBaseMortgageCategory_ApplicationStartEvent();
    message.loanUuid = object.loanUuid ?? "";
    message.borrowerUuid = object.borrowerUuid ?? "";
    message.entrySource = object.entrySource ?? 0;
    return message;
  },
};

function createBaseMortgageCategory_StepViewEvent(): MortgageCategory_StepViewEvent {
  return { loanUuid: "", borrowerUuid: "", stepKey: 0, isFirstView: false, isReturnVisit: false };
}

export const MortgageCategory_StepViewEvent = {
  fromJSON(object: any): MortgageCategory_StepViewEvent {
    return {
      loanUuid: isSet(object.loanUuid) ? String(object.loanUuid) : "",
      borrowerUuid: isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
      stepKey: isSet(object.stepKey) ? mortgageCategory_StepKeyFromJSON(object.stepKey) : 0,
      isFirstView: isSet(object.isFirstView) ? Boolean(object.isFirstView) : false,
      isReturnVisit: isSet(object.isReturnVisit) ? Boolean(object.isReturnVisit) : false,
    };
  },

  toJSON(message: MortgageCategory_StepViewEvent): unknown {
    const obj: any = {};
    if (message.loanUuid !== "") {
      obj.loanUuid = message.loanUuid;
    }
    if (message.borrowerUuid !== "") {
      obj.borrowerUuid = message.borrowerUuid;
    }
    if (message.stepKey !== 0) {
      obj.stepKey = mortgageCategory_StepKeyToJSON(message.stepKey);
    }
    if (message.isFirstView === true) {
      obj.isFirstView = message.isFirstView;
    }
    if (message.isReturnVisit === true) {
      obj.isReturnVisit = message.isReturnVisit;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_StepViewEvent>, I>>(base?: I): MortgageCategory_StepViewEvent {
    return MortgageCategory_StepViewEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_StepViewEvent>, I>>(
    object: I,
  ): MortgageCategory_StepViewEvent {
    const message = createBaseMortgageCategory_StepViewEvent();
    message.loanUuid = object.loanUuid ?? "";
    message.borrowerUuid = object.borrowerUuid ?? "";
    message.stepKey = object.stepKey ?? 0;
    message.isFirstView = object.isFirstView ?? false;
    message.isReturnVisit = object.isReturnVisit ?? false;
    return message;
  },
};

function createBaseMortgageCategory_StepCompleteEvent(): MortgageCategory_StepCompleteEvent {
  return {
    loanUuid: "",
    borrowerUuid: "",
    stepKey: 0,
    durationMs: 0,
    integrationType: 0,
    integrationSuccess: undefined,
  };
}

export const MortgageCategory_StepCompleteEvent = {
  fromJSON(object: any): MortgageCategory_StepCompleteEvent {
    return {
      loanUuid: isSet(object.loanUuid) ? String(object.loanUuid) : "",
      borrowerUuid: isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
      stepKey: isSet(object.stepKey) ? mortgageCategory_StepKeyFromJSON(object.stepKey) : 0,
      durationMs: isSet(object.durationMs) ? Number(object.durationMs) : 0,
      integrationType: isSet(object.integrationType)
        ? mortgageCategory_IntegrationTypeFromJSON(object.integrationType)
        : 0,
      integrationSuccess: isSet(object.integrationSuccess) ? Boolean(object.integrationSuccess) : undefined,
    };
  },

  toJSON(message: MortgageCategory_StepCompleteEvent): unknown {
    const obj: any = {};
    if (message.loanUuid !== "") {
      obj.loanUuid = message.loanUuid;
    }
    if (message.borrowerUuid !== "") {
      obj.borrowerUuid = message.borrowerUuid;
    }
    if (message.stepKey !== 0) {
      obj.stepKey = mortgageCategory_StepKeyToJSON(message.stepKey);
    }
    if (message.durationMs !== 0) {
      obj.durationMs = Math.round(message.durationMs);
    }
    if (message.integrationType !== 0) {
      obj.integrationType = mortgageCategory_IntegrationTypeToJSON(message.integrationType);
    }
    if (message.integrationSuccess !== undefined) {
      obj.integrationSuccess = message.integrationSuccess;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_StepCompleteEvent>, I>>(
    base?: I,
  ): MortgageCategory_StepCompleteEvent {
    return MortgageCategory_StepCompleteEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_StepCompleteEvent>, I>>(
    object: I,
  ): MortgageCategory_StepCompleteEvent {
    const message = createBaseMortgageCategory_StepCompleteEvent();
    message.loanUuid = object.loanUuid ?? "";
    message.borrowerUuid = object.borrowerUuid ?? "";
    message.stepKey = object.stepKey ?? 0;
    message.durationMs = object.durationMs ?? 0;
    message.integrationType = object.integrationType ?? 0;
    message.integrationSuccess = object.integrationSuccess ?? undefined;
    return message;
  },
};

function createBaseMortgageCategory_ApplicationSubmitEvent(): MortgageCategory_ApplicationSubmitEvent {
  return { loanUuid: "", borrowerUuid: "", totalDurationMs: 0, integrationsUsed: [] };
}

export const MortgageCategory_ApplicationSubmitEvent = {
  fromJSON(object: any): MortgageCategory_ApplicationSubmitEvent {
    return {
      loanUuid: isSet(object.loanUuid) ? String(object.loanUuid) : "",
      borrowerUuid: isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
      totalDurationMs: isSet(object.totalDurationMs) ? Number(object.totalDurationMs) : 0,
      integrationsUsed: Array.isArray(object?.integrationsUsed)
        ? object.integrationsUsed.map((e: any) => mortgageCategory_IntegrationTypeFromJSON(e))
        : [],
    };
  },

  toJSON(message: MortgageCategory_ApplicationSubmitEvent): unknown {
    const obj: any = {};
    if (message.loanUuid !== "") {
      obj.loanUuid = message.loanUuid;
    }
    if (message.borrowerUuid !== "") {
      obj.borrowerUuid = message.borrowerUuid;
    }
    if (message.totalDurationMs !== 0) {
      obj.totalDurationMs = Math.round(message.totalDurationMs);
    }
    if (message.integrationsUsed?.length) {
      obj.integrationsUsed = message.integrationsUsed.map((e) => mortgageCategory_IntegrationTypeToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_ApplicationSubmitEvent>, I>>(
    base?: I,
  ): MortgageCategory_ApplicationSubmitEvent {
    return MortgageCategory_ApplicationSubmitEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_ApplicationSubmitEvent>, I>>(
    object: I,
  ): MortgageCategory_ApplicationSubmitEvent {
    const message = createBaseMortgageCategory_ApplicationSubmitEvent();
    message.loanUuid = object.loanUuid ?? "";
    message.borrowerUuid = object.borrowerUuid ?? "";
    message.totalDurationMs = object.totalDurationMs ?? 0;
    message.integrationsUsed = object.integrationsUsed?.map((e) => e) || [];
    return message;
  },
};

function createBaseMortgageCategory_ApplicationDecisionEvent(): MortgageCategory_ApplicationDecisionEvent {
  return { loanUuid: "", borrowerUuid: "", timeToDecisionMs: 0, decisionType: 0 };
}

export const MortgageCategory_ApplicationDecisionEvent = {
  fromJSON(object: any): MortgageCategory_ApplicationDecisionEvent {
    return {
      loanUuid: isSet(object.loanUuid) ? String(object.loanUuid) : "",
      borrowerUuid: isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
      timeToDecisionMs: isSet(object.timeToDecisionMs) ? Number(object.timeToDecisionMs) : 0,
      decisionType: isSet(object.decisionType) ? mortgageCategory_DecisionTypeFromJSON(object.decisionType) : 0,
    };
  },

  toJSON(message: MortgageCategory_ApplicationDecisionEvent): unknown {
    const obj: any = {};
    if (message.loanUuid !== "") {
      obj.loanUuid = message.loanUuid;
    }
    if (message.borrowerUuid !== "") {
      obj.borrowerUuid = message.borrowerUuid;
    }
    if (message.timeToDecisionMs !== 0) {
      obj.timeToDecisionMs = Math.round(message.timeToDecisionMs);
    }
    if (message.decisionType !== 0) {
      obj.decisionType = mortgageCategory_DecisionTypeToJSON(message.decisionType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_ApplicationDecisionEvent>, I>>(
    base?: I,
  ): MortgageCategory_ApplicationDecisionEvent {
    return MortgageCategory_ApplicationDecisionEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_ApplicationDecisionEvent>, I>>(
    object: I,
  ): MortgageCategory_ApplicationDecisionEvent {
    const message = createBaseMortgageCategory_ApplicationDecisionEvent();
    message.loanUuid = object.loanUuid ?? "";
    message.borrowerUuid = object.borrowerUuid ?? "";
    message.timeToDecisionMs = object.timeToDecisionMs ?? 0;
    message.decisionType = object.decisionType ?? 0;
    return message;
  },
};

function createBaseMortgageCategory_IntegrationStartEvent(): MortgageCategory_IntegrationStartEvent {
  return { loanUuid: "", borrowerUuid: "", integrationType: 0 };
}

export const MortgageCategory_IntegrationStartEvent = {
  fromJSON(object: any): MortgageCategory_IntegrationStartEvent {
    return {
      loanUuid: isSet(object.loanUuid) ? String(object.loanUuid) : "",
      borrowerUuid: isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
      integrationType: isSet(object.integrationType)
        ? mortgageCategory_IntegrationTypeFromJSON(object.integrationType)
        : 0,
    };
  },

  toJSON(message: MortgageCategory_IntegrationStartEvent): unknown {
    const obj: any = {};
    if (message.loanUuid !== "") {
      obj.loanUuid = message.loanUuid;
    }
    if (message.borrowerUuid !== "") {
      obj.borrowerUuid = message.borrowerUuid;
    }
    if (message.integrationType !== 0) {
      obj.integrationType = mortgageCategory_IntegrationTypeToJSON(message.integrationType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_IntegrationStartEvent>, I>>(
    base?: I,
  ): MortgageCategory_IntegrationStartEvent {
    return MortgageCategory_IntegrationStartEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_IntegrationStartEvent>, I>>(
    object: I,
  ): MortgageCategory_IntegrationStartEvent {
    const message = createBaseMortgageCategory_IntegrationStartEvent();
    message.loanUuid = object.loanUuid ?? "";
    message.borrowerUuid = object.borrowerUuid ?? "";
    message.integrationType = object.integrationType ?? 0;
    return message;
  },
};

function createBaseMortgageCategory_IntegrationResultEvent(): MortgageCategory_IntegrationResultEvent {
  return { loanUuid: "", borrowerUuid: "", integrationType: 0, result: 0, durationMs: 0, failureReason: 0 };
}

export const MortgageCategory_IntegrationResultEvent = {
  fromJSON(object: any): MortgageCategory_IntegrationResultEvent {
    return {
      loanUuid: isSet(object.loanUuid) ? String(object.loanUuid) : "",
      borrowerUuid: isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
      integrationType: isSet(object.integrationType)
        ? mortgageCategory_IntegrationTypeFromJSON(object.integrationType)
        : 0,
      result: isSet(object.result) ? mortgageCategory_IntegrationResultFromJSON(object.result) : 0,
      durationMs: isSet(object.durationMs) ? Number(object.durationMs) : 0,
      failureReason: isSet(object.failureReason) ? mortgageCategory_FailureReasonFromJSON(object.failureReason) : 0,
    };
  },

  toJSON(message: MortgageCategory_IntegrationResultEvent): unknown {
    const obj: any = {};
    if (message.loanUuid !== "") {
      obj.loanUuid = message.loanUuid;
    }
    if (message.borrowerUuid !== "") {
      obj.borrowerUuid = message.borrowerUuid;
    }
    if (message.integrationType !== 0) {
      obj.integrationType = mortgageCategory_IntegrationTypeToJSON(message.integrationType);
    }
    if (message.result !== 0) {
      obj.result = mortgageCategory_IntegrationResultToJSON(message.result);
    }
    if (message.durationMs !== 0) {
      obj.durationMs = Math.round(message.durationMs);
    }
    if (message.failureReason !== 0) {
      obj.failureReason = mortgageCategory_FailureReasonToJSON(message.failureReason);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_IntegrationResultEvent>, I>>(
    base?: I,
  ): MortgageCategory_IntegrationResultEvent {
    return MortgageCategory_IntegrationResultEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_IntegrationResultEvent>, I>>(
    object: I,
  ): MortgageCategory_IntegrationResultEvent {
    const message = createBaseMortgageCategory_IntegrationResultEvent();
    message.loanUuid = object.loanUuid ?? "";
    message.borrowerUuid = object.borrowerUuid ?? "";
    message.integrationType = object.integrationType ?? 0;
    message.result = object.result ?? 0;
    message.durationMs = object.durationMs ?? 0;
    message.failureReason = object.failureReason ?? 0;
    return message;
  },
};

function createBaseMortgageCategory_ProductPricingStartEvent(): MortgageCategory_ProductPricingStartEvent {
  return { loanUuid: "", borrowerUuid: "", downPaymentPercent: 0, optionsCount: 0 };
}

export const MortgageCategory_ProductPricingStartEvent = {
  fromJSON(object: any): MortgageCategory_ProductPricingStartEvent {
    return {
      loanUuid: isSet(object.loanUuid) ? String(object.loanUuid) : "",
      borrowerUuid: isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
      downPaymentPercent: isSet(object.downPaymentPercent) ? Number(object.downPaymentPercent) : 0,
      optionsCount: isSet(object.optionsCount) ? Number(object.optionsCount) : 0,
    };
  },

  toJSON(message: MortgageCategory_ProductPricingStartEvent): unknown {
    const obj: any = {};
    if (message.loanUuid !== "") {
      obj.loanUuid = message.loanUuid;
    }
    if (message.borrowerUuid !== "") {
      obj.borrowerUuid = message.borrowerUuid;
    }
    if (message.downPaymentPercent !== 0) {
      obj.downPaymentPercent = Math.round(message.downPaymentPercent);
    }
    if (message.optionsCount !== 0) {
      obj.optionsCount = Math.round(message.optionsCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_ProductPricingStartEvent>, I>>(
    base?: I,
  ): MortgageCategory_ProductPricingStartEvent {
    return MortgageCategory_ProductPricingStartEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_ProductPricingStartEvent>, I>>(
    object: I,
  ): MortgageCategory_ProductPricingStartEvent {
    const message = createBaseMortgageCategory_ProductPricingStartEvent();
    message.loanUuid = object.loanUuid ?? "";
    message.borrowerUuid = object.borrowerUuid ?? "";
    message.downPaymentPercent = object.downPaymentPercent ?? 0;
    message.optionsCount = object.optionsCount ?? 0;
    return message;
  },
};

function createBaseMortgageCategory_OutOfPocketMaxSelectionEvent(): MortgageCategory_OutOfPocketMaxSelectionEvent {
  return { loanUuid: "", borrowerUuid: "", outOfPocketMaxCents: 0 };
}

export const MortgageCategory_OutOfPocketMaxSelectionEvent = {
  fromJSON(object: any): MortgageCategory_OutOfPocketMaxSelectionEvent {
    return {
      loanUuid: isSet(object.loanUuid) ? String(object.loanUuid) : "",
      borrowerUuid: isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
      outOfPocketMaxCents: isSet(object.outOfPocketMaxCents) ? Number(object.outOfPocketMaxCents) : 0,
    };
  },

  toJSON(message: MortgageCategory_OutOfPocketMaxSelectionEvent): unknown {
    const obj: any = {};
    if (message.loanUuid !== "") {
      obj.loanUuid = message.loanUuid;
    }
    if (message.borrowerUuid !== "") {
      obj.borrowerUuid = message.borrowerUuid;
    }
    if (message.outOfPocketMaxCents !== 0) {
      obj.outOfPocketMaxCents = Math.round(message.outOfPocketMaxCents);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_OutOfPocketMaxSelectionEvent>, I>>(
    base?: I,
  ): MortgageCategory_OutOfPocketMaxSelectionEvent {
    return MortgageCategory_OutOfPocketMaxSelectionEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_OutOfPocketMaxSelectionEvent>, I>>(
    object: I,
  ): MortgageCategory_OutOfPocketMaxSelectionEvent {
    const message = createBaseMortgageCategory_OutOfPocketMaxSelectionEvent();
    message.loanUuid = object.loanUuid ?? "";
    message.borrowerUuid = object.borrowerUuid ?? "";
    message.outOfPocketMaxCents = object.outOfPocketMaxCents ?? 0;
    return message;
  },
};

function createBaseMortgageCategory_DownPaymentSelectionEvent(): MortgageCategory_DownPaymentSelectionEvent {
  return { loanUuid: "", borrowerUuid: "", downPaymentPercent: 0, isCustom: false };
}

export const MortgageCategory_DownPaymentSelectionEvent = {
  fromJSON(object: any): MortgageCategory_DownPaymentSelectionEvent {
    return {
      loanUuid: isSet(object.loanUuid) ? String(object.loanUuid) : "",
      borrowerUuid: isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
      downPaymentPercent: isSet(object.downPaymentPercent) ? Number(object.downPaymentPercent) : 0,
      isCustom: isSet(object.isCustom) ? Boolean(object.isCustom) : false,
    };
  },

  toJSON(message: MortgageCategory_DownPaymentSelectionEvent): unknown {
    const obj: any = {};
    if (message.loanUuid !== "") {
      obj.loanUuid = message.loanUuid;
    }
    if (message.borrowerUuid !== "") {
      obj.borrowerUuid = message.borrowerUuid;
    }
    if (message.downPaymentPercent !== 0) {
      obj.downPaymentPercent = Math.round(message.downPaymentPercent);
    }
    if (message.isCustom === true) {
      obj.isCustom = message.isCustom;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_DownPaymentSelectionEvent>, I>>(
    base?: I,
  ): MortgageCategory_DownPaymentSelectionEvent {
    return MortgageCategory_DownPaymentSelectionEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_DownPaymentSelectionEvent>, I>>(
    object: I,
  ): MortgageCategory_DownPaymentSelectionEvent {
    const message = createBaseMortgageCategory_DownPaymentSelectionEvent();
    message.loanUuid = object.loanUuid ?? "";
    message.borrowerUuid = object.borrowerUuid ?? "";
    message.downPaymentPercent = object.downPaymentPercent ?? 0;
    message.isCustom = object.isCustom ?? false;
    return message;
  },
};

function createBaseMortgageCategory_ProductPricingSelectEvent(): MortgageCategory_ProductPricingSelectEvent {
  return { loanUuid: "", borrowerUuid: "", ratePercent: "", lockPeriodDays: 0, monthlyPaymentCents: 0 };
}

export const MortgageCategory_ProductPricingSelectEvent = {
  fromJSON(object: any): MortgageCategory_ProductPricingSelectEvent {
    return {
      loanUuid: isSet(object.loanUuid) ? String(object.loanUuid) : "",
      borrowerUuid: isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
      ratePercent: isSet(object.ratePercent) ? String(object.ratePercent) : "",
      lockPeriodDays: isSet(object.lockPeriodDays) ? Number(object.lockPeriodDays) : 0,
      monthlyPaymentCents: isSet(object.monthlyPaymentCents) ? Number(object.monthlyPaymentCents) : 0,
    };
  },

  toJSON(message: MortgageCategory_ProductPricingSelectEvent): unknown {
    const obj: any = {};
    if (message.loanUuid !== "") {
      obj.loanUuid = message.loanUuid;
    }
    if (message.borrowerUuid !== "") {
      obj.borrowerUuid = message.borrowerUuid;
    }
    if (message.ratePercent !== "") {
      obj.ratePercent = message.ratePercent;
    }
    if (message.lockPeriodDays !== 0) {
      obj.lockPeriodDays = Math.round(message.lockPeriodDays);
    }
    if (message.monthlyPaymentCents !== 0) {
      obj.monthlyPaymentCents = Math.round(message.monthlyPaymentCents);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_ProductPricingSelectEvent>, I>>(
    base?: I,
  ): MortgageCategory_ProductPricingSelectEvent {
    return MortgageCategory_ProductPricingSelectEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_ProductPricingSelectEvent>, I>>(
    object: I,
  ): MortgageCategory_ProductPricingSelectEvent {
    const message = createBaseMortgageCategory_ProductPricingSelectEvent();
    message.loanUuid = object.loanUuid ?? "";
    message.borrowerUuid = object.borrowerUuid ?? "";
    message.ratePercent = object.ratePercent ?? "";
    message.lockPeriodDays = object.lockPeriodDays ?? 0;
    message.monthlyPaymentCents = object.monthlyPaymentCents ?? 0;
    return message;
  },
};

function createBaseMortgageCategory_ProductPricingSeeDetailsEvent(): MortgageCategory_ProductPricingSeeDetailsEvent {
  return { loanUuid: "", borrowerUuid: "", ratePercent: "" };
}

export const MortgageCategory_ProductPricingSeeDetailsEvent = {
  fromJSON(object: any): MortgageCategory_ProductPricingSeeDetailsEvent {
    return {
      loanUuid: isSet(object.loanUuid) ? String(object.loanUuid) : "",
      borrowerUuid: isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
      ratePercent: isSet(object.ratePercent) ? String(object.ratePercent) : "",
    };
  },

  toJSON(message: MortgageCategory_ProductPricingSeeDetailsEvent): unknown {
    const obj: any = {};
    if (message.loanUuid !== "") {
      obj.loanUuid = message.loanUuid;
    }
    if (message.borrowerUuid !== "") {
      obj.borrowerUuid = message.borrowerUuid;
    }
    if (message.ratePercent !== "") {
      obj.ratePercent = message.ratePercent;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_ProductPricingSeeDetailsEvent>, I>>(
    base?: I,
  ): MortgageCategory_ProductPricingSeeDetailsEvent {
    return MortgageCategory_ProductPricingSeeDetailsEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_ProductPricingSeeDetailsEvent>, I>>(
    object: I,
  ): MortgageCategory_ProductPricingSeeDetailsEvent {
    const message = createBaseMortgageCategory_ProductPricingSeeDetailsEvent();
    message.loanUuid = object.loanUuid ?? "";
    message.borrowerUuid = object.borrowerUuid ?? "";
    message.ratePercent = object.ratePercent ?? "";
    return message;
  },
};

function createBaseMortgageCategory_RateLockStartEvent(): MortgageCategory_RateLockStartEvent {
  return { loanUuid: "", borrowerUuid: "", ratePercent: "", lockPeriodDays: 0 };
}

export const MortgageCategory_RateLockStartEvent = {
  fromJSON(object: any): MortgageCategory_RateLockStartEvent {
    return {
      loanUuid: isSet(object.loanUuid) ? String(object.loanUuid) : "",
      borrowerUuid: isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
      ratePercent: isSet(object.ratePercent) ? String(object.ratePercent) : "",
      lockPeriodDays: isSet(object.lockPeriodDays) ? Number(object.lockPeriodDays) : 0,
    };
  },

  toJSON(message: MortgageCategory_RateLockStartEvent): unknown {
    const obj: any = {};
    if (message.loanUuid !== "") {
      obj.loanUuid = message.loanUuid;
    }
    if (message.borrowerUuid !== "") {
      obj.borrowerUuid = message.borrowerUuid;
    }
    if (message.ratePercent !== "") {
      obj.ratePercent = message.ratePercent;
    }
    if (message.lockPeriodDays !== 0) {
      obj.lockPeriodDays = Math.round(message.lockPeriodDays);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_RateLockStartEvent>, I>>(
    base?: I,
  ): MortgageCategory_RateLockStartEvent {
    return MortgageCategory_RateLockStartEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_RateLockStartEvent>, I>>(
    object: I,
  ): MortgageCategory_RateLockStartEvent {
    const message = createBaseMortgageCategory_RateLockStartEvent();
    message.loanUuid = object.loanUuid ?? "";
    message.borrowerUuid = object.borrowerUuid ?? "";
    message.ratePercent = object.ratePercent ?? "";
    message.lockPeriodDays = object.lockPeriodDays ?? 0;
    return message;
  },
};

function createBaseMortgageCategory_RateLockCompleteEvent(): MortgageCategory_RateLockCompleteEvent {
  return {
    loanUuid: "",
    borrowerUuid: "",
    ratePercent: "",
    downPaymentPercent: 0,
    monthlyPaymentCents: 0,
    cashToCloseCents: 0,
  };
}

export const MortgageCategory_RateLockCompleteEvent = {
  fromJSON(object: any): MortgageCategory_RateLockCompleteEvent {
    return {
      loanUuid: isSet(object.loanUuid) ? String(object.loanUuid) : "",
      borrowerUuid: isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
      ratePercent: isSet(object.ratePercent) ? String(object.ratePercent) : "",
      downPaymentPercent: isSet(object.downPaymentPercent) ? Number(object.downPaymentPercent) : 0,
      monthlyPaymentCents: isSet(object.monthlyPaymentCents) ? Number(object.monthlyPaymentCents) : 0,
      cashToCloseCents: isSet(object.cashToCloseCents) ? Number(object.cashToCloseCents) : 0,
    };
  },

  toJSON(message: MortgageCategory_RateLockCompleteEvent): unknown {
    const obj: any = {};
    if (message.loanUuid !== "") {
      obj.loanUuid = message.loanUuid;
    }
    if (message.borrowerUuid !== "") {
      obj.borrowerUuid = message.borrowerUuid;
    }
    if (message.ratePercent !== "") {
      obj.ratePercent = message.ratePercent;
    }
    if (message.downPaymentPercent !== 0) {
      obj.downPaymentPercent = Math.round(message.downPaymentPercent);
    }
    if (message.monthlyPaymentCents !== 0) {
      obj.monthlyPaymentCents = Math.round(message.monthlyPaymentCents);
    }
    if (message.cashToCloseCents !== 0) {
      obj.cashToCloseCents = Math.round(message.cashToCloseCents);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_RateLockCompleteEvent>, I>>(
    base?: I,
  ): MortgageCategory_RateLockCompleteEvent {
    return MortgageCategory_RateLockCompleteEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_RateLockCompleteEvent>, I>>(
    object: I,
  ): MortgageCategory_RateLockCompleteEvent {
    const message = createBaseMortgageCategory_RateLockCompleteEvent();
    message.loanUuid = object.loanUuid ?? "";
    message.borrowerUuid = object.borrowerUuid ?? "";
    message.ratePercent = object.ratePercent ?? "";
    message.downPaymentPercent = object.downPaymentPercent ?? 0;
    message.monthlyPaymentCents = object.monthlyPaymentCents ?? 0;
    message.cashToCloseCents = object.cashToCloseCents ?? 0;
    return message;
  },
};

function createBaseMortgageCategory_DisclosuresSignedEvent(): MortgageCategory_DisclosuresSignedEvent {
  return { loanUuid: "", borrowerUuid: "" };
}

export const MortgageCategory_DisclosuresSignedEvent = {
  fromJSON(object: any): MortgageCategory_DisclosuresSignedEvent {
    return {
      loanUuid: isSet(object.loanUuid) ? String(object.loanUuid) : "",
      borrowerUuid: isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
    };
  },

  toJSON(message: MortgageCategory_DisclosuresSignedEvent): unknown {
    const obj: any = {};
    if (message.loanUuid !== "") {
      obj.loanUuid = message.loanUuid;
    }
    if (message.borrowerUuid !== "") {
      obj.borrowerUuid = message.borrowerUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_DisclosuresSignedEvent>, I>>(
    base?: I,
  ): MortgageCategory_DisclosuresSignedEvent {
    return MortgageCategory_DisclosuresSignedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_DisclosuresSignedEvent>, I>>(
    object: I,
  ): MortgageCategory_DisclosuresSignedEvent {
    const message = createBaseMortgageCategory_DisclosuresSignedEvent();
    message.loanUuid = object.loanUuid ?? "";
    message.borrowerUuid = object.borrowerUuid ?? "";
    return message;
  },
};

function createBaseMortgageCategory_ValidationErrorEvent(): MortgageCategory_ValidationErrorEvent {
  return { loanUuid: "", borrowerUuid: "", stepKey: 0, fieldName: "", errorType: 0 };
}

export const MortgageCategory_ValidationErrorEvent = {
  fromJSON(object: any): MortgageCategory_ValidationErrorEvent {
    return {
      loanUuid: isSet(object.loanUuid) ? String(object.loanUuid) : "",
      borrowerUuid: isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
      stepKey: isSet(object.stepKey) ? mortgageCategory_StepKeyFromJSON(object.stepKey) : 0,
      fieldName: isSet(object.fieldName) ? String(object.fieldName) : "",
      errorType: isSet(object.errorType) ? mortgageCategory_ValidationErrorTypeFromJSON(object.errorType) : 0,
    };
  },

  toJSON(message: MortgageCategory_ValidationErrorEvent): unknown {
    const obj: any = {};
    if (message.loanUuid !== "") {
      obj.loanUuid = message.loanUuid;
    }
    if (message.borrowerUuid !== "") {
      obj.borrowerUuid = message.borrowerUuid;
    }
    if (message.stepKey !== 0) {
      obj.stepKey = mortgageCategory_StepKeyToJSON(message.stepKey);
    }
    if (message.fieldName !== "") {
      obj.fieldName = message.fieldName;
    }
    if (message.errorType !== 0) {
      obj.errorType = mortgageCategory_ValidationErrorTypeToJSON(message.errorType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_ValidationErrorEvent>, I>>(
    base?: I,
  ): MortgageCategory_ValidationErrorEvent {
    return MortgageCategory_ValidationErrorEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_ValidationErrorEvent>, I>>(
    object: I,
  ): MortgageCategory_ValidationErrorEvent {
    const message = createBaseMortgageCategory_ValidationErrorEvent();
    message.loanUuid = object.loanUuid ?? "";
    message.borrowerUuid = object.borrowerUuid ?? "";
    message.stepKey = object.stepKey ?? 0;
    message.fieldName = object.fieldName ?? "";
    message.errorType = object.errorType ?? 0;
    return message;
  },
};

function createBaseMortgageCategory_PrequalStartEvent(): MortgageCategory_PrequalStartEvent {
  return { prequalApplicationId: "", customerUuid: undefined, prequalChannel: 0, prequalLinkId: undefined };
}

export const MortgageCategory_PrequalStartEvent = {
  fromJSON(object: any): MortgageCategory_PrequalStartEvent {
    return {
      prequalApplicationId: isSet(object.prequalApplicationId) ? String(object.prequalApplicationId) : "",
      customerUuid: isSet(object.customerUuid) ? String(object.customerUuid) : undefined,
      prequalChannel: isSet(object.prequalChannel) ? mortgageCategory_PrequalChannelFromJSON(object.prequalChannel) : 0,
      prequalLinkId: isSet(object.prequalLinkId) ? String(object.prequalLinkId) : undefined,
    };
  },

  toJSON(message: MortgageCategory_PrequalStartEvent): unknown {
    const obj: any = {};
    if (message.prequalApplicationId !== "") {
      obj.prequalApplicationId = message.prequalApplicationId;
    }
    if (message.customerUuid !== undefined) {
      obj.customerUuid = message.customerUuid;
    }
    if (message.prequalChannel !== 0) {
      obj.prequalChannel = mortgageCategory_PrequalChannelToJSON(message.prequalChannel);
    }
    if (message.prequalLinkId !== undefined) {
      obj.prequalLinkId = message.prequalLinkId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_PrequalStartEvent>, I>>(
    base?: I,
  ): MortgageCategory_PrequalStartEvent {
    return MortgageCategory_PrequalStartEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_PrequalStartEvent>, I>>(
    object: I,
  ): MortgageCategory_PrequalStartEvent {
    const message = createBaseMortgageCategory_PrequalStartEvent();
    message.prequalApplicationId = object.prequalApplicationId ?? "";
    message.customerUuid = object.customerUuid ?? undefined;
    message.prequalChannel = object.prequalChannel ?? 0;
    message.prequalLinkId = object.prequalLinkId ?? undefined;
    return message;
  },
};

function createBaseMortgageCategory_PrequalStepViewEvent(): MortgageCategory_PrequalStepViewEvent {
  return { prequalApplicationId: "", customerUuid: undefined, stepKey: 0, isFirstView: false, isReturnVisit: false };
}

export const MortgageCategory_PrequalStepViewEvent = {
  fromJSON(object: any): MortgageCategory_PrequalStepViewEvent {
    return {
      prequalApplicationId: isSet(object.prequalApplicationId) ? String(object.prequalApplicationId) : "",
      customerUuid: isSet(object.customerUuid) ? String(object.customerUuid) : undefined,
      stepKey: isSet(object.stepKey) ? mortgageCategory_PrequalStepKeyFromJSON(object.stepKey) : 0,
      isFirstView: isSet(object.isFirstView) ? Boolean(object.isFirstView) : false,
      isReturnVisit: isSet(object.isReturnVisit) ? Boolean(object.isReturnVisit) : false,
    };
  },

  toJSON(message: MortgageCategory_PrequalStepViewEvent): unknown {
    const obj: any = {};
    if (message.prequalApplicationId !== "") {
      obj.prequalApplicationId = message.prequalApplicationId;
    }
    if (message.customerUuid !== undefined) {
      obj.customerUuid = message.customerUuid;
    }
    if (message.stepKey !== 0) {
      obj.stepKey = mortgageCategory_PrequalStepKeyToJSON(message.stepKey);
    }
    if (message.isFirstView === true) {
      obj.isFirstView = message.isFirstView;
    }
    if (message.isReturnVisit === true) {
      obj.isReturnVisit = message.isReturnVisit;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_PrequalStepViewEvent>, I>>(
    base?: I,
  ): MortgageCategory_PrequalStepViewEvent {
    return MortgageCategory_PrequalStepViewEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_PrequalStepViewEvent>, I>>(
    object: I,
  ): MortgageCategory_PrequalStepViewEvent {
    const message = createBaseMortgageCategory_PrequalStepViewEvent();
    message.prequalApplicationId = object.prequalApplicationId ?? "";
    message.customerUuid = object.customerUuid ?? undefined;
    message.stepKey = object.stepKey ?? 0;
    message.isFirstView = object.isFirstView ?? false;
    message.isReturnVisit = object.isReturnVisit ?? false;
    return message;
  },
};

function createBaseMortgageCategory_PrequalStepCompleteEvent(): MortgageCategory_PrequalStepCompleteEvent {
  return { prequalApplicationId: "", customerUuid: undefined, stepKey: 0, durationMs: 0 };
}

export const MortgageCategory_PrequalStepCompleteEvent = {
  fromJSON(object: any): MortgageCategory_PrequalStepCompleteEvent {
    return {
      prequalApplicationId: isSet(object.prequalApplicationId) ? String(object.prequalApplicationId) : "",
      customerUuid: isSet(object.customerUuid) ? String(object.customerUuid) : undefined,
      stepKey: isSet(object.stepKey) ? mortgageCategory_PrequalStepKeyFromJSON(object.stepKey) : 0,
      durationMs: isSet(object.durationMs) ? Number(object.durationMs) : 0,
    };
  },

  toJSON(message: MortgageCategory_PrequalStepCompleteEvent): unknown {
    const obj: any = {};
    if (message.prequalApplicationId !== "") {
      obj.prequalApplicationId = message.prequalApplicationId;
    }
    if (message.customerUuid !== undefined) {
      obj.customerUuid = message.customerUuid;
    }
    if (message.stepKey !== 0) {
      obj.stepKey = mortgageCategory_PrequalStepKeyToJSON(message.stepKey);
    }
    if (message.durationMs !== 0) {
      obj.durationMs = Math.round(message.durationMs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_PrequalStepCompleteEvent>, I>>(
    base?: I,
  ): MortgageCategory_PrequalStepCompleteEvent {
    return MortgageCategory_PrequalStepCompleteEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_PrequalStepCompleteEvent>, I>>(
    object: I,
  ): MortgageCategory_PrequalStepCompleteEvent {
    const message = createBaseMortgageCategory_PrequalStepCompleteEvent();
    message.prequalApplicationId = object.prequalApplicationId ?? "";
    message.customerUuid = object.customerUuid ?? undefined;
    message.stepKey = object.stepKey ?? 0;
    message.durationMs = object.durationMs ?? 0;
    return message;
  },
};

function createBaseMortgageCategory_PrequalSubmitEvent(): MortgageCategory_PrequalSubmitEvent {
  return {
    prequalApplicationId: "",
    customerUuid: undefined,
    totalDurationMs: 0,
    prequalChannel: 0,
    stepsCompleted: 0,
  };
}

export const MortgageCategory_PrequalSubmitEvent = {
  fromJSON(object: any): MortgageCategory_PrequalSubmitEvent {
    return {
      prequalApplicationId: isSet(object.prequalApplicationId) ? String(object.prequalApplicationId) : "",
      customerUuid: isSet(object.customerUuid) ? String(object.customerUuid) : undefined,
      totalDurationMs: isSet(object.totalDurationMs) ? Number(object.totalDurationMs) : 0,
      prequalChannel: isSet(object.prequalChannel) ? mortgageCategory_PrequalChannelFromJSON(object.prequalChannel) : 0,
      stepsCompleted: isSet(object.stepsCompleted) ? Number(object.stepsCompleted) : 0,
    };
  },

  toJSON(message: MortgageCategory_PrequalSubmitEvent): unknown {
    const obj: any = {};
    if (message.prequalApplicationId !== "") {
      obj.prequalApplicationId = message.prequalApplicationId;
    }
    if (message.customerUuid !== undefined) {
      obj.customerUuid = message.customerUuid;
    }
    if (message.totalDurationMs !== 0) {
      obj.totalDurationMs = Math.round(message.totalDurationMs);
    }
    if (message.prequalChannel !== 0) {
      obj.prequalChannel = mortgageCategory_PrequalChannelToJSON(message.prequalChannel);
    }
    if (message.stepsCompleted !== 0) {
      obj.stepsCompleted = Math.round(message.stepsCompleted);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_PrequalSubmitEvent>, I>>(
    base?: I,
  ): MortgageCategory_PrequalSubmitEvent {
    return MortgageCategory_PrequalSubmitEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_PrequalSubmitEvent>, I>>(
    object: I,
  ): MortgageCategory_PrequalSubmitEvent {
    const message = createBaseMortgageCategory_PrequalSubmitEvent();
    message.prequalApplicationId = object.prequalApplicationId ?? "";
    message.customerUuid = object.customerUuid ?? undefined;
    message.totalDurationMs = object.totalDurationMs ?? 0;
    message.prequalChannel = object.prequalChannel ?? 0;
    message.stepsCompleted = object.stepsCompleted ?? 0;
    return message;
  },
};

function createBaseMortgageCategory_PrequalDecisionEvent(): MortgageCategory_PrequalDecisionEvent {
  return {
    prequalApplicationId: "",
    customerUuid: undefined,
    timeToDecisionMs: 0,
    decisionType: 0,
    maxLoanAmountCents: undefined,
    ratePercent: undefined,
  };
}

export const MortgageCategory_PrequalDecisionEvent = {
  fromJSON(object: any): MortgageCategory_PrequalDecisionEvent {
    return {
      prequalApplicationId: isSet(object.prequalApplicationId) ? String(object.prequalApplicationId) : "",
      customerUuid: isSet(object.customerUuid) ? String(object.customerUuid) : undefined,
      timeToDecisionMs: isSet(object.timeToDecisionMs) ? Number(object.timeToDecisionMs) : 0,
      decisionType: isSet(object.decisionType) ? mortgageCategory_PrequalDecisionTypeFromJSON(object.decisionType) : 0,
      maxLoanAmountCents: isSet(object.maxLoanAmountCents) ? Number(object.maxLoanAmountCents) : undefined,
      ratePercent: isSet(object.ratePercent) ? String(object.ratePercent) : undefined,
    };
  },

  toJSON(message: MortgageCategory_PrequalDecisionEvent): unknown {
    const obj: any = {};
    if (message.prequalApplicationId !== "") {
      obj.prequalApplicationId = message.prequalApplicationId;
    }
    if (message.customerUuid !== undefined) {
      obj.customerUuid = message.customerUuid;
    }
    if (message.timeToDecisionMs !== 0) {
      obj.timeToDecisionMs = Math.round(message.timeToDecisionMs);
    }
    if (message.decisionType !== 0) {
      obj.decisionType = mortgageCategory_PrequalDecisionTypeToJSON(message.decisionType);
    }
    if (message.maxLoanAmountCents !== undefined) {
      obj.maxLoanAmountCents = message.maxLoanAmountCents;
    }
    if (message.ratePercent !== undefined) {
      obj.ratePercent = message.ratePercent;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_PrequalDecisionEvent>, I>>(
    base?: I,
  ): MortgageCategory_PrequalDecisionEvent {
    return MortgageCategory_PrequalDecisionEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_PrequalDecisionEvent>, I>>(
    object: I,
  ): MortgageCategory_PrequalDecisionEvent {
    const message = createBaseMortgageCategory_PrequalDecisionEvent();
    message.prequalApplicationId = object.prequalApplicationId ?? "";
    message.customerUuid = object.customerUuid ?? undefined;
    message.timeToDecisionMs = object.timeToDecisionMs ?? 0;
    message.decisionType = object.decisionType ?? 0;
    message.maxLoanAmountCents = object.maxLoanAmountCents ?? undefined;
    message.ratePercent = object.ratePercent ?? undefined;
    return message;
  },
};

function createBaseMortgageCategory_LowerReferralEvent(): MortgageCategory_LowerReferralEvent {
  return { prequalApplicationId: "", customerUuid: undefined, success: false, referralReason: 0 };
}

export const MortgageCategory_LowerReferralEvent = {
  fromJSON(object: any): MortgageCategory_LowerReferralEvent {
    return {
      prequalApplicationId: isSet(object.prequalApplicationId) ? String(object.prequalApplicationId) : "",
      customerUuid: isSet(object.customerUuid) ? String(object.customerUuid) : undefined,
      success: isSet(object.success) ? Boolean(object.success) : false,
      referralReason: isSet(object.referralReason)
        ? mortgageCategory_PrequalDecisionTypeFromJSON(object.referralReason)
        : 0,
    };
  },

  toJSON(message: MortgageCategory_LowerReferralEvent): unknown {
    const obj: any = {};
    if (message.prequalApplicationId !== "") {
      obj.prequalApplicationId = message.prequalApplicationId;
    }
    if (message.customerUuid !== undefined) {
      obj.customerUuid = message.customerUuid;
    }
    if (message.success === true) {
      obj.success = message.success;
    }
    if (message.referralReason !== 0) {
      obj.referralReason = mortgageCategory_PrequalDecisionTypeToJSON(message.referralReason);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_LowerReferralEvent>, I>>(
    base?: I,
  ): MortgageCategory_LowerReferralEvent {
    return MortgageCategory_LowerReferralEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_LowerReferralEvent>, I>>(
    object: I,
  ): MortgageCategory_LowerReferralEvent {
    const message = createBaseMortgageCategory_LowerReferralEvent();
    message.prequalApplicationId = object.prequalApplicationId ?? "";
    message.customerUuid = object.customerUuid ?? undefined;
    message.success = object.success ?? false;
    message.referralReason = object.referralReason ?? 0;
    return message;
  },
};

function createBaseMortgageCategory_PrequalValidationErrorEvent(): MortgageCategory_PrequalValidationErrorEvent {
  return { prequalApplicationId: "", customerUuid: undefined, stepKey: 0, fieldName: "", errorType: 0 };
}

export const MortgageCategory_PrequalValidationErrorEvent = {
  fromJSON(object: any): MortgageCategory_PrequalValidationErrorEvent {
    return {
      prequalApplicationId: isSet(object.prequalApplicationId) ? String(object.prequalApplicationId) : "",
      customerUuid: isSet(object.customerUuid) ? String(object.customerUuid) : undefined,
      stepKey: isSet(object.stepKey) ? mortgageCategory_PrequalStepKeyFromJSON(object.stepKey) : 0,
      fieldName: isSet(object.fieldName) ? String(object.fieldName) : "",
      errorType: isSet(object.errorType) ? mortgageCategory_ValidationErrorTypeFromJSON(object.errorType) : 0,
    };
  },

  toJSON(message: MortgageCategory_PrequalValidationErrorEvent): unknown {
    const obj: any = {};
    if (message.prequalApplicationId !== "") {
      obj.prequalApplicationId = message.prequalApplicationId;
    }
    if (message.customerUuid !== undefined) {
      obj.customerUuid = message.customerUuid;
    }
    if (message.stepKey !== 0) {
      obj.stepKey = mortgageCategory_PrequalStepKeyToJSON(message.stepKey);
    }
    if (message.fieldName !== "") {
      obj.fieldName = message.fieldName;
    }
    if (message.errorType !== 0) {
      obj.errorType = mortgageCategory_ValidationErrorTypeToJSON(message.errorType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MortgageCategory_PrequalValidationErrorEvent>, I>>(
    base?: I,
  ): MortgageCategory_PrequalValidationErrorEvent {
    return MortgageCategory_PrequalValidationErrorEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MortgageCategory_PrequalValidationErrorEvent>, I>>(
    object: I,
  ): MortgageCategory_PrequalValidationErrorEvent {
    const message = createBaseMortgageCategory_PrequalValidationErrorEvent();
    message.prequalApplicationId = object.prequalApplicationId ?? "";
    message.customerUuid = object.customerUuid ?? undefined;
    message.stepKey = object.stepKey ?? 0;
    message.fieldName = object.fieldName ?? "";
    message.errorType = object.errorType ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
